module.exports = __webpack_public_path__ + "static/media/searching-testers.5d2c695d.png";